import React from 'react'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import colors from 'theme/colors'
import routeParams from 'theme/routeParams'
import useAcceptedInviteRedirect from 'modules/dashboard/producer-access/useAcceptedInviteRedirect'

/**
 * Resposta do link do e-mail de permissão no evento. Aceitou: a pessoa vai
 * para o painel do produtor (useAcceptedInviteRedirect); este modal só avisa
 * enquanto ela está de saída, e traz o resultado de recusa e de erro.
 */
export default function InvitePermissionAlert({ visible, data, onClose }) {
    const { redirecting } = useAcceptedInviteRedirect({
        active: !!visible && data?.type == 'accept',
        producerId: data?.producerId,
        inviteParams: new URLSearchParams({
            [routeParams.permissions.invitePermission]: 'accept',
            [routeParams.permissions.invitePermissionEvent]: data?.event || '',
            [routeParams.permissions.invitePermissionProducer]: data?.producerId || '',
        }),
    })

    if (redirecting) return null

    return (
        <Modal isOpen={!!visible} closeButton={true} onClose={onClose}>
            {
                data?.type == 'accept' && (
                    <>
                        <Text name='normal' type='bold' color={colors.successLight}>
                            Convite aceito
                        </Text>

                        <Text color={colors.night}>
                            Parabéns! Agora você tem permissão para validação no evento <b>"{data?.event}"</b>.
                        </Text>
                    </>
                )
            }

            {
                data?.type == 'reject' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Convite recusado
                        </Text>

                        <Text color={colors.night}>
                            Você recusou o convite para ter permissão de validação no evento <b>"{data?.event}"</b>.
                        </Text>
                    </>
                )
            }

            {
                data?.type == 'error' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Ocorreu um erro
                        </Text>

                        <Text color={colors.night}>
                            Ocorreu um erro inesperado durante o seu convite, entre em contato com o responsavel do evento.
                        </Text>
                    </>
                )
            }
        </Modal>
    )
}
